<button
    type="button"
    class="button"
    [class.with-icon]="buttonIcon"
    [ngClass]="buttonType"
    (click)="uploadPhoto()"
>
    <i class="icon-plus" *ngIf="buttonIcon"></i>
    {{ buttonText }}
</button>
